"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_USER_HOLDING_VIEW = void 0;
const client_1 = require("@apollo/client");
exports.UPDATE_USER_HOLDING_VIEW = client_1.gql `
  mutation updateUserHoldingView($input: InputUpdateUserHoldingView!) {
    updateUserHoldingView(input: $input) {
      id
    }
  }
`;
